define('controller/BookingController',['require','view/controller/booking/BookingLayout','view/controller/booking/BookingInfoView','view/controller/booking/timezone/CompanyTimeView','view/controller/booking/BackButtonView','view/controller/booking/result/BookingResultLayout','view/controller/booking/reschedule/BookingRescheduleLayout','model/BookingModel','model/WaitingListHelperModel','model/BookingRescheduleModel','controller/step/BookingStepManager','controller/step/BookingRescheduleStepManager','lib/controller/BaseController','lib/view/BookingUrlBuilder','view/controller/booking/BookingRescheduleUrlBuilder','model/ClientTimeZoneModel','model/CompanyTimeZoneModel','model/TimeValidateModel','collection/TimeZoneCollection','Config','lib/plugin/PluginBroker','lib/Utils','lib/Navigation','lib/view/mixin/BookingResultPopupMixin'],function (require) {	
	
	var BookingLayout = require('view/controller/booking/BookingLayout');
	var BookingInfoView = require('view/controller/booking/BookingInfoView');
    var CompanyTimeView = require('view/controller/booking/timezone/CompanyTimeView');
	var BackButtonView = require('view/controller/booking/BackButtonView');
	var BookingResultLayout = require('view/controller/booking/result/BookingResultLayout');
	var BookingRescheduleLayout = require('view/controller/booking/reschedule/BookingRescheduleLayout');
	var BookingModel = require('model/BookingModel');
	var WaitingListHelperModel = require('model/WaitingListHelperModel');
	var BookingRescheduleModel = require('model/BookingRescheduleModel');
	var BookingStepManager = require('controller/step/BookingStepManager');
	var BookingRescheduleStepManager = require('controller/step/BookingRescheduleStepManager');
	var BaseController = require('lib/controller/BaseController');
	var BookingUrlBuilder = require('lib/view/BookingUrlBuilder');
	var BookingRescheduleUrlBuilder = require('view/controller/booking/BookingRescheduleUrlBuilder');
    var ClientTimeZoneModel = require('model/ClientTimeZoneModel');
	var CompanyTimeZoneModel = require('model/CompanyTimeZoneModel');
	var TimeValidateModel = require('model/TimeValidateModel');
    var TimeZoneCollection = require('collection/TimeZoneCollection');
    var Config = require('Config');
	
	var PluginBroker = require('lib/plugin/PluginBroker');
	var Utils = require('lib/Utils');
	var Navigation = require('lib/Navigation');
	var BookingResultPopupMixin = require('lib/view/mixin/BookingResultPopupMixin');

	/**
	 * Booking controller
	 * 
	 * @class BookingController
	 */
	return BaseController.extend({
	
		_bookingModel: null,
		_clientModel: null,
		_timeValidateModel: null,
	    _bookingLayout: null,
	    _bookingStepManager: null,

		_companyTimeZone: null,
		_clientTimeZone: null,
		_requestModel: null,
	
	    /**
	     * initialize controller class
	     * init BookingModel and BookingUrlBuilder
	     */
	    initialize: function () {
	    	BaseController.prototype.initialize.call(this);
	    	
	    	this._bookingModel = new BookingModel();
			this._companyTimeZone = new CompanyTimeZoneModel();
			this._clientTimeZone = new ClientTimeZoneModel();
			this._timeValidateModel = new TimeValidateModel();

			this._clientModel = this.getOption('clientModel');

            this.listenTo(this._clientTimeZone, 'sync', _.bind(function () {
                this._bookingModel.set('timezone', this._clientTimeZone.get('id'));
			}, this));

            var stepParams = {
				clientModel: this._clientModel,
				companyTimeZone: this._companyTimeZone,
				clientTimeZone: this._clientTimeZone,
				timeValidateModel: this._timeValidateModel
			};

			if (Config.getInstance().getPluginStatus('waiting_list')){
				var waitingListHelperModel = new WaitingListHelperModel();
				waitingListHelperModel.setModels(_.extend({
					bookingModel: this._bookingModel,
				}, stepParams));
				stepParams = _.extend({
					waitingListHelperModel: waitingListHelperModel,
				}, stepParams);
			}

	    	this._bookingStepManager = new BookingStepManager({
	    		bookingModel: this._bookingModel,
				timeValidateModel: this._timeValidateModel,
				stepParams: stepParams,
	    	});
	    	this.listenTo(this._bookingStepManager, 'stepDone', this.showNextStep);
			this.listenTo(this._bookingStepManager, 'bookingDone', this.showStepAfterBooking);
	    	
	    	PluginBroker.getInstance().setStepManager(this._bookingStepManager);
	    	BookingUrlBuilder.getInstance().setBookingModel(this._bookingModel);
	    },

        bookService: function () {
            BookingUrlBuilder.getInstance().setBookingMode('service');

            this.index.apply(this, arguments);
		},

		bookClass: function () {
            BookingUrlBuilder.getInstance().setBookingMode('class');

            this.index.apply(this, arguments);
		},

        bookServiceClassesProvider: function () {
            BookingUrlBuilder.getInstance().setBookingMode('service');

            this.indexClassesProvider.apply(this, arguments);
		},

        bookClassClassesProvider: function () {
            BookingUrlBuilder.getInstance().setBookingMode('class');

            this.indexClassesProvider.apply(this, arguments);
		},

        /**
		 * Alias for index action for classes timeline (provider is after time selection)
         * @return {*}
         */
        indexClassesProvider: function (location, category, service, count, addons, date, time, provider, isWl, r, someTrash ) {
			return this.index(location, category, service, count, addons, provider, date, time, isWl, r, someTrash);
		},

	    /**
	     * index action
	     * fills _bookingModel from input params and displays required step
	     */
	    index: function(location, category, service, count, addons, provider, date, time, isWl, r, someTrash) {
			if(someTrash){
				console.warn('Some trash in booking controller url: ', someTrash);
			}
            
            if (this._currentStepManager == 'reschedule') {
                // debugger;
                if (this._rescheduleStepManager) {
                    this._rescheduleStepManager.clearCollectionFilters();
                }
                this._bookingStepManager.clearSteps();
                this._currentStepManager = 'booking';
                PluginBroker.getInstance().setStepManager(this._bookingStepManager);
            }
            
	    	var predefined = Config.getInstance().getOption('predefined') || {};

            if(isWl){
            	time = '00:00';
			}

	    	var data = {
	    		'location_id': location,
	    		'category_id': category,
	    		'service_id': service,
	    		'provider_id': provider,
	    		'start_date': date,
	    		'start_time': time,
                'addons': addons,
				'wl' : isWl,
	    	};
            var extraData = {};

	    	if(count){
	    		data['count'] = count;
                extraData['count_set'] = true;
			}

	    	_.each(predefined, function (value, index) {
	    		var key = index + '_id';
                if (data.hasOwnProperty(index) && !data[index] && value) {
                    data[index] = value;
                }
				if (data.hasOwnProperty(key) && !data[key] && value) {
					data[key] = value;
				}
			});

	    	this._bookingModel.set(data, extraData);

            this._bookingStepManager.initializeSteps();

            // displays company time, user time, timezone, etc.
            var timeZoneCollection = new TimeZoneCollection();

            var companyTimeView = new CompanyTimeView({
                companyTimeZone: this._companyTimeZone,
                clientTimeZone: this._clientTimeZone,
                timeZoneCollection: timeZoneCollection
            });
            this._getBookingLayout().getTimeRegion().show(companyTimeView);

            // back button
            this._getBookingLayout().getBackButtonRegion().show(new BackButtonView({
				stepManager: this._bookingStepManager
			}));

	    	this.showNextStep();
	    },

		/**
		 * After booking is finished we should run the steps after details.
		 */
		showStepAfterBooking: function (requestModel) {
			this._requestModel = requestModel;

			var ids = [];
			this._requestModel.get('bookings').each(function (model) {
				ids.push(model.get('id'));
			});
			
			PluginBroker.getInstance().perform('onFinishBooking', [{
				currency: this._requestModel.get('currency'),
				amount: this._requestModel.get('amount'),
				bookings: this._requestModel.get('bookings'),
				booking_ids: ids,
				invoice: this._requestModel.get('invoice'),
				confirm: this._requestModel.get('confirm'),
				require_confirm: this._requestModel.get('require_confirm'),
			}]);

			this.showNextStep('details');
		},

	    /**
	     * Booking list action. Displays list of client bookings
		 *
         * @param String type
	     */
	    clientBookings: function (type, id, isWl) {
	    	var bookingResultLayout = new BookingResultLayout({
	    		data: {
	    			type: type,
                    highlighted: id ? id.split(',') : [],
					wl: isWl,
				},
				clientTimeZone: this._clientTimeZone,
				clientModel: this._clientModel,
				wl: isWl,
			});

			this.getMainLayout().getContentRegion().show(bookingResultLayout);
        },

		/**
		 * Booking list action. Displays list of client bookings
		 *
		 * @param String ids
		 * @param String status
		 * @param Integer cartId
		 * @param String paymentSystem
		 */
		clientBookingsResult: function (ids, status, isWl, cartId, paymentSystem) {
			var data = {
				booking_ids: ids,
				status: status,
				cartId: cartId,
				wl: isWl,
				paymentSystem: paymentSystem
			};
			var bookingResultLayout = new BookingResultLayout({
				data: data,
				clientTimeZone: this._clientTimeZone,
				clientModel: this._clientModel,
				wl: isWl,
			});

			Utils.sendIframePostMessage({
				event: 'bookingDone'
			});

			this.getMainLayout().getContentRegion().show(bookingResultLayout);
		},

		/**
		 * Display bookings list and show cancel dialog
		 *
		 * @param Integer bookingId
		 */
		clientBookingsCancel: function (bookingId) {
			var bookingResultLayout = new BookingResultLayout({
				data: {
					cancelBookingId: bookingId
				},
				clientTimeZone: this._clientTimeZone
			});

			this.getMainLayout().getContentRegion().show(bookingResultLayout);
		},

		/**
		 * @param bookingId
		 * @param date
		 * @param time
		 */
		clientBookingsReschedule: function (bookingId, date, time) {
            if (this._rescheduleStepManager) {
                this._rescheduleStepManager.clearCollectionFilters();
            }
            if (this._currentStepManager != 'reschedule') {
                this._bookingStepManager.clearCollectionFilters();
                this._currentStepManager = 'reschedule';
            }
            
            var bookingModel = new BookingRescheduleModel({
                id: bookingId,
                timezone: this._clientTimeZone.get('id')
            });
            
            this.listenTo(this._clientTimeZone, 'sync', _.bind(function () {
                bookingModel.set('timezone', this._clientTimeZone.get('id'));
			}, this));
            
            if (date) {
                bookingModel.set({
                    date: date,
                    time: time
                });
                this.listenToOnce(bookingModel, 'error', function (model, xhr) {
                    this.stopListening(bookingModel);
                    bookingModel.setErrors([{
                        field: 'global',
                        error: xhr.responseJSON ? xhr.responseJSON.error : xhr.responseText
                    }]);
                    bookingModel.fetch();
                    
                    // console.log('error', xhr.responseJSON ? xhr.responseJSON.error : xhr.responseText);
                });
                // NB on success, not on 'sync': Navigation.go() routes synchronously and destroys the reschedule
                // layout, and Backbone would still call its 'sync' listeners later in the same dispatch
                // (ViewDestroyedError). success runs before 'sync' is triggered.
                bookingModel.save(null, {
                    success: _.bind(function () {
                        this.stopListening(bookingModel);
                        // a new result: the popup shows once per status and booking ids, an earlier reschedule
                        // of this booking would hide it
                        BookingResultPopupMixin.resetBookingResultPopup('reschedule_success', bookingModel.id);
                        // replace: Back must not return to the date/time route, it would save the reschedule again
                        Navigation.go('client/bookings/ids/' + bookingModel.id + '/status/reschedule_success', {
                            replace: true
                        });
                    }, this)
                });
            } else {
                bookingModel.fetch();
            }
            
            BookingRescheduleUrlBuilder.getInstance().setBookingModel(bookingModel);

            var stepParams = {
				clientModel: this._clientModel,
				companyTimeZone: this._companyTimeZone,
				clientTimeZone: this._clientTimeZone,
				timeValidateModel: this._timeValidateModel
			};

			if (Config.getInstance().getPluginStatus('waiting_list')){
				var waitingListHelperModel = new WaitingListHelperModel();
				waitingListHelperModel.setModels(_.extend({
					bookingModel: bookingModel,
				}, stepParams));
				stepParams = _.extend({
					waitingListHelperModel: waitingListHelperModel,
				}, stepParams);
			}
            
            var bookingStepManager = this._rescheduleStepManager = new BookingRescheduleStepManager({
	    		bookingModel: bookingModel,
				stepParams: stepParams,
	    	});
            
            //TODONOW clear collections by plugins
            PluginBroker.getInstance().setStepManager(this._rescheduleStepManager);
            
            //NB this loads service/provider collections etc., but causes timeline to load multiple times...
            bookingStepManager.initializeSteps();

            var rescheduleLayout = new BookingRescheduleLayout({
                model: bookingModel,
                stepManager: bookingStepManager,
                companyTimeZone: this._companyTimeZone,
                clientTimeZone: this._clientTimeZone,
				stepParams: {
	    			clientModel: this._clientModel,
					companyTimeZone: this._companyTimeZone,
	    			clientTimeZone: this._clientTimeZone,
					timeValidateModel: this._timeValidateModel
				}
            });
            this.getMainLayout().getContentRegion().show(rescheduleLayout);
		},

        /**
		 * Updates booking info navigation
         */
        updateBookingInfo: function () {
            // displays current booking information
            var bookingInfoView = new BookingInfoView({
                model: this._bookingModel,
                bookingStepManager: this._bookingStepManager,
                companyTimeZone: this._companyTimeZone,
                clientTimeZone: this._clientTimeZone,
                timeValidateModel: this._timeValidateModel,
                currentStep: this._currentStep
            });
            this._getBookingLayout().getInfoRegion().show(bookingInfoView);
		},

	    /**
	     * Displays next required step in region
		 *
		 * @param String nextTo
	     */
	    showNextStep: function (nextTo) {
	    	if (this._currentStepManager === 'reschedule') {
	    		return;
			}
	    	var nextStep = this._bookingStepManager.getNextStep(nextTo);
	    	if (nextStep) {
                var stepObject = this._bookingStepManager.getStepObject(nextStep);

                stepObject.start();

	    		if (this._currentStep === nextStep) {
	    			stepObject.refreshView();
	    			
					return;
				}

				this._currentStep = nextStep;

				if (stepObject.hasView()) {
					var view = stepObject.getStepView();

					this._getBookingLayout().getContentRegion().reset();
					this._getBookingLayout().getContentRegion().show(view);
					this.updateBookingInfo();
				} else {
					if (stepObject.clearContent()) {
						this._getBookingLayout().getContentRegion().reset();
					}

					// show next step in case returns true
					if (stepObject.processStep()) {
						this.showNextStep(nextStep);
					}
				}

                Backbone.Wreqr.radio.vent.trigger('booking', 'step:changed', {
                    'step': nextStep,
					'has_view': stepObject.hasView(),
					'booking': this._bookingModel.toJSON()
                });
	    	} else {
	    		var params = {};
	    		if (this._requestModel) {
	    			params.ids = [];
					if (this._requestModel.get('bookings')) {
						this._requestModel.get('bookings').each(function (model) {
							params.ids.push(model.get('id'));
						});
					}
					params.status = 'success';
					//if (this._requestModel.get('require_confirm')) {
					//	params.status = 'pending';
					//}
					if (Config.getInstance().getPluginStatus('approve_booking')) {
						params.status = 'pending';
					}

					if (Config.getInstance().getPluginStatus('waiting_list') && this._requestModel.get('waiting_list')) {
						params.status = 'success';
						params.waiting_list = true;
					}
				}

                Backbone.history.navigate(
                    BookingUrlBuilder.getInstance().buildUrl('finish_step', params), {trigger: true}
                );
			}
	    },
	    
	    /**
	     * Inits BookingLayout
	     * Shows BookingLayout in content region of application
	     * 
	     * @return BookingLayout
	     */
	    _getBookingLayout: function () {
	    	if (!this._bookingLayout || this._bookingLayout.isDestroyed) {
	    	    this._currentStep = null;

	    		this._bookingLayout = new BookingLayout();
	    		this.getMainLayout().getContentRegion().show(this._bookingLayout);
	    	}
	    	
	    	return this._bookingLayout;
	    }
	    
	});
	
});
